module.exports = __webpack_public_path__ + "img/logo.2d27fa9f.png";